export enum DataProvidersStorageKey {
  COUNTRY_GROUPS = 'countryGroups',
  FUEL_PRICES = 'fuelPrices',
}
